module.exports = __webpack_public_path__ + "static/media/contractSign.979b152d.svg";